module.exports = __webpack_public_path__ + "static/img/kv.42fd497b.jpg";